import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import KidErrorBoundary from "@/components/KidErrorBoundary";
import { installChunkErrorRecovery } from "@/lib/cacheBuster";

// Auto-recuperación ante archivos viejos en caché tras un deploy.
installChunkErrorRecovery();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <KidErrorBoundary>
      <App />
    </KidErrorBoundary>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
